import React from 'react'
import { Button, Divider, Group, NativeSelect, Stack } from '@mantine/core'
import { useForm } from '@mantine/form'
import { useWidgetEditor } from './state'

export function ContainerForm(props: { id: string }) {
  const editor = useWidgetEditor()
  const isSaving = editor.useIsSaving()
  const config = editor.useConfig(props.id)
  const form = useForm({
    mode: 'uncontrolled',
    initialValues: structuredClone(config.options),
  })

  const onSubmit = React.useCallback(
    (values: unknown) => {
      editor.setOptions(values)
      editor.save()
    },
    [editor]
  )

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Stack gap="sm">
        <Divider label="Period Filter" />
        {/*<Switch {...form.getInputProps('periodFilter')} label="Enabled" />*/}
        <NativeSelect
          {...form.getInputProps('direction')}
          label="Direction"
          data={[
            { value: 'horizontal', label: 'Horizontal' },
            { value: 'vertical', label: 'Vertical' },
          ]}
        />
      </Stack>

      <Group justify="flex-end" mt="md">
        <Button color="red.4" variant="outline" onClick={editor.endEditWidget}>
          Cancel
        </Button>
        <Button type="submit" loading={isSaving}>
          Save
        </Button>
      </Group>
    </form>
  )
}
